import {useSelector} from 'react-redux';
import {selectFabricArt} from '~/common/fabric/reducers/fabricDesign/selectors';

type EviteEventFabricDesign = {
  backgroundImage: {
    width: number;
    height: number;
  };
};

export enum TemplateOrientationEnum {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
  SQUARE = 'square',
}

export const TEMPLATE_ORIENTATIONS = [
  {name: TemplateOrientationEnum.PORTRAIT, size: [1000, 1360] as const},
  {name: TemplateOrientationEnum.LANDSCAPE, size: [1360, 1000] as const},
  {name: TemplateOrientationEnum.SQUARE, size: [1360, 1360] as const},
] as const;

export function getOrientation(width: number, height: number): TemplateOrientationEnum {
  // look for an exact match
  const found = TEMPLATE_ORIENTATIONS.find((o) => o.size[0] === width && o.size[1] === height);
  // default back to portrait
  return found ? found.name : TEMPLATE_ORIENTATIONS[0].name;
}

export const useOrientation = () => {
  let fabricArt = useSelector(selectFabricArt);
  // fabricArt will be undefined when on /view route, so fallback to eviteEvent
  const eviteEventFabricDesign: EviteEventFabricDesign = useSelector(
    // biome-ignore lint/style/useNamingConvention: existing error
    (state: {eviteEvent: {fabric_design_data: EviteEventFabricDesign}}) =>
      state.eviteEvent.fabric_design_data
  );
  if (!fabricArt || !fabricArt.backgroundImage) {
    fabricArt = eviteEventFabricDesign;
  }
  if (!fabricArt || !fabricArt.backgroundImage) {
    return TemplateOrientationEnum.PORTRAIT;
  }

  const {width, height} = fabricArt.backgroundImage;

  return getOrientation(width, height);
};
